import styled from 'styled-components';

export const Container = styled.div`
  color: ${({ theme }) => theme.color.highlight};
`;
